import ImageList from './ImageList';
import {connect} from "react-redux";
import { selectors as imageSelectors , actions as imageActions } from '../../Image';
import { selectors as businessCardSelectors } from '../../BusinessCard';

//const {getGalleryImages} = imageSelectors;
const { addGalleryImages,removeGalleryImages } = imageActions;
const { getCardImages } = businessCardSelectors;

const mapDispatchToProps =  (dispatch) => {
    return {
        onRemove: (imageFilesToDelete) => dispatch(removeGalleryImages(imageFilesToDelete)),
        onFilesSelected: (files) => {
           // const imageFiles = processSeletctedFiles(files);
            dispatch(addGalleryImages(files));
        }
    };
}

const mapStateToProps = (state) => {
    return {
        imageFiles: getCardImages(state).galleryImages
    };
}

export default connect(mapStateToProps,mapDispatchToProps)(ImageList);